import { render, staticRenderFns } from "./JournalsList.vue?vue&type=template&id=e14277e6"
import script from "./JournalsList.vue?vue&type=script&lang=js"
export * from "./JournalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports